import React from "react";
import Styles from "../styles/index";

export function buildWhatsappUrl({
  toNumber,
  name,
  empreendimento,
  facialLink,
  customMessage,
}) {
  if (!toNumber) return null;

  const safeName = name || "";
  const safeEmpreendimento = empreendimento || "";
  const safeFacialLink = facialLink || "";

  const baseMessage = customMessage
    ? customMessage
    : `Olá! Sou ${safeName} Emprendimento: ${safeEmpreendimento}.`;

  const message = `${baseMessage} \ facial: ${safeFacialLink}`;

  return `https://wa.me/${toNumber}?text=${encodeURIComponent(message)}`;
}

export function MenssageWhatsapp({
  data,
  renterId,
  toNumber,
  customMessage = "",
  children,
}) {
  if (!data) return null;

  const isPrimary = data.primaryGuest?.id === renterId;
  const user = isPrimary ? data?.primaryGuest : data?.secondaryGuests?.id || {};
  const name = user?.name ?? "";

  const empreendimento =
    data.place?.name ||
    (Array.isArray(data.places) ? data.places[0]?.name : "") ||
    "";

  const facialLink =
    (typeof window !== "undefined" ? window.location.href : "") || "";

  const url = buildWhatsappUrl({
    toNumber,
    name,
    empreendimento,
    facialLink,
    customMessage,
  });

  if (!url) return null;

  return (
    <Styles.Container>
      <Styles.Buttonlink
        style={{
          fontSize: "0.65em",
          color: "#0C396D",
          padding: "12px",
          borderRadius: "15px",
          marginTop: "1vh",
          fontWeight: "bold",
          textDecoration: "underline",
          textAlign: "center",
        }}
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {"Tendo problemas com a facial?"}
      </Styles.Buttonlink>
    </Styles.Container>
  );
}
